import { Input } from "@material-ui/core";
import Button from "@material-ui/core/Button";
import IconButton from "@material-ui/core/IconButton";
import InputAdornment from "@material-ui/core/InputAdornment";
import Tooltip from "@material-ui/core/Tooltip";
import Typography from "@material-ui/core/Typography";
import CopyIcon from "@material-ui/icons/FileCopy";
import InfoIcon from "@material-ui/icons/Info";
import Visibility from "@material-ui/icons/Visibility";
import VisibilityOff from "@material-ui/icons/VisibilityOff";
import React from "react";
import { languages } from "../../constants/languages";
import { copyToClipboard } from "../../util/CopyToClipboard";

export default class AdminLoginLink extends React.Component {
  state = {
    code: "",
    loaded: false,
    show: false,
  };

  UNSAFE_componentWillMount = () => {
    const tournamentRef = window.firebase
      .firestore()
      .collection("tournaments")
      .doc(this.props.tournament[".key"]);

    this.unsubscribe = tournamentRef
      .collection("adminCodes")
      .onSnapshot((querySnapshot) => {
        let code = "";
        querySnapshot.forEach(function (doc) {
          code = doc.id;
        });

        this.setState({
          code: code,
          loaded: true,
        });
      });
  };

  createCode = () => {
    const batch = window.firebase.firestore().batch();
    const tournamentRef = window.firebase
      .firestore()
      .collection("tournaments")
      .doc(this.props.tournament[".key"]);
    if (this.state.code) {
      batch.delete(tournamentRef.collection("adminCodes").doc(this.state.code));
    }
    const codeDoc = tournamentRef.collection("adminCodes").doc();
    batch.set(codeDoc, { type: "admin" });
    batch.commit();
  };

  deleteCode = () => {
    window.firebase
      .firestore()
      .collection("tournaments")
      .doc(this.props.tournament[".key"])
      .collection("adminCodes")
      .doc(this.state.code)
      .delete();
  };

  toggleShow = () => {
    this.setState({ show: !this.state.show });
  };

  render() {
    const code =
      (this.props.tournament.isPSD || this.props.tournament.crqpsd
        ? "tournify.prosoccerdata.com/"
        : "tournifyapp.com/live/") +
      this.props.tournament.liveLink +
      "/admin/" +
      this.state.code;
    if (this.state.loaded) {
      if (!this.state.code) {
        return (
          <div>
            <Button
              onClick={this.createCode}
              variant="contained"
              color="primary"
              disabled={!this.props.tournament.liveLink}
              style={{ marginTop: 10 }}
            >
              {languages.createTournament.create}
            </Button>
          </div>
        );
      } else {
        return (
          <div>
            <div style={{ display: "flex", alignItems: "center" }}>
              <Input
                disabled
                variant="outlined"
                value={code}
                type={this.state.show ? "text" : "password"}
                style={{ flexGrow: 1 }}
                endAdornment={
                  <InputAdornment position="end">
                    <IconButton
                      aria-label="toggle password visibility"
                      onClick={this.toggleShow}
                    >
                      {this.state.show ? <Visibility /> : <VisibilityOff />}
                    </IconButton>
                  </InputAdornment>
                }
              />
              <Tooltip title={languages.general.copy} placement="top">
                <IconButton
                  onClick={() => {
                    copyToClipboard("https://" + code);
                  }}
                >
                  <CopyIcon />
                </IconButton>
              </Tooltip>
              <Button
                onClick={this.deleteCode}
                variant="contained"
                color="primary"
              >
                {languages.admins.resetLoginLink}
              </Button>
            </div>
            <div>
              <Typography
                variant="body2"
                style={{
                  background: "#FFECB3",
                  padding: 10,
                  borderRadius: 5,
                  marginTop: 5,
                  width: "100%",
                }}
              >
                <InfoIcon
                  style={{
                    height: 15,
                    width: 15,
                    top: 2,
                    marginRight: 5,
                    position: "relative",
                  }}
                />
                {languages.formatString(
                  languages.admins.adminLoginLinkDescription2,
                  this.props.tournament.individualPlayers
                    ? languages.teams.playersLow
                    : languages.tournament.teamsLow,
                  this.props.tournament.useJudges
                    ? languages.referees.judgesLow
                    : languages.schedule.refereesLow
                )}
              </Typography>
            </div>
          </div>
        );
      }
    }
    return <div></div>;
  }
}
